import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProfileGuru from "./Profile/ProfileGuru";
import ProfileSiswa from "./Profile/ProfileSiswa";
import TampilanKepsek from "./Profile/TampilanKepsek";

const ProfileUser = () => {
  const { id } = useParams();
  const [jabatan, setJabatan] = useState("");
  const [user, setUser] = useState({});
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token && id) {
      axios
        .get(`${process.env.REACT_APP_API_URL}api/auth/users/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setUser(response.data);
          setRole(response.data.role);
          setJabatan(response.data.jabatan);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setError("Gagal memuat data user");
          setLoading(false);
        });
    }
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-5">
      {/* ===== JUDUL ===== */}
      <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
        {role === "guru" ? "Profile Guru" : "Profile"}
      </h1>

      {/* ===== KARTU PROFILE ===== */}
      <div className="flex justify-center mb-10 perspective">
        <div className="relative w-full max-w-sm h-[420px] group">
          <div className="absolute inset-0 transition-transform duration-700 card-3d group-hover:rotate-y-180">
            {/* ================= DEPAN ================= */}
            <div className="absolute inset-0 bg-white shadow-xl rounded-xl p-6 backface-hidden">
              <div className="flex flex-col items-center">
                {user.image?.filename ? (
                  <img
                    src={`${process.env.REACT_APP_API_URL}api/auth/users/image/${user.image.filename}`}
                    alt={user.name}
                    className="w-32 h-32 rounded-full object-cover border-4 border-cyan-500"
                  />
                ) : (
                  <div className="w-32 h-32 rounded-full bg-gray-300 flex items-center justify-center">
                    N/A
                  </div>
                )}

                <h2 className="mt-4 text-lg font-bold text-gray-800 text-center">
                  {user.name}
                </h2>

                {/* ===== NIP / NISN ===== */}
                <p className="text-sm text-gray-600 mt-1">
                  {role === "siswa" ? (
                    <>NISN: {user.NISN || "-"}</>
                  ) : (
                    <>NIP: {user.NIP || "-"}</>
                  )}
                </p>

                <span className="mt-3 px-4 py-1 rounded-full text-sm bg-cyan-100 text-cyan-700">
                  {jabatan}
                </span>
              </div>
            </div>

            {/* ================= BELAKANG ================= */}
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500 to-blue-600 text-white shadow-xl rounded-xl p-6 rotate-y-180 backface-hidden">
              <h3 className="text-lg font-bold text-center mb-4 border-b border-white/30 pb-2">
                Data Diri
              </h3>

              <div className="space-y-2 text-sm">
                {/* STATUS HANYA UNTUK NON SISWA */}
                {role !== "siswa" && (
                  <p>
                    <strong>Status:</strong> {user.statusPPH || "-"}
                  </p>
                )}

                <p>
                  <strong>Jabatan:</strong> {jabatan}
                </p>

                <p>
                  <strong>Jenis Kelamin:</strong> {user.kelamin || "-"}
                </p>

                <p>
                  <strong>Tempat Lahir:</strong> {user.TL || "-"}
                </p>

                <p>
                  <strong>Tanggal Lahir:</strong>{" "}
                  {user.TGL
                    ? new Date(user.TGL).toLocaleDateString("id-ID", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                    : "-"}
                </p>

                {/* DATA KHUSUS SISWA */}
                {role === "siswa" && (
                  <>
                    <p>
                      <strong>Nama Ayah:</strong> {user.ayah || "-"}
                    </p>
                    <p>
                      <strong>Nama Ibu:</strong> {user.ibu || "-"}
                    </p>
                    <p>
                      <strong>Nama Wali:</strong> {user.wali || "-"}
                    </p>
                  </>
                )}

                {/* GURU */}
                {jabatan === "Guru Kelas" && (
                  <p>
                    <strong>Kelas:</strong> {user.kelas} {user.rombel}
                  </p>
                )}

                {jabatan === "Guru Mapel" && (
                  <p>
                    <strong>Mapel:</strong> {user.mapel}
                  </p>
                )}
              </div>

              <div className="absolute bottom-4 left-0 right-0 text-center text-xs opacity-80">
                ID Card
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== KOMPONEN TAMBAHAN ===== */}
      {role === "siswa" ? (
        <ProfileSiswa id={id} />
      ) : role === "guru" && jabatan === "Kepala Sekolah" ? (
        <TampilanKepsek id={id} />
      ) : role === "guru" ? (
        <ProfileGuru id={id} />
      ) : null}
    </div>
  );
};

export default ProfileUser;
